export default {
  en: {
    sendEmail: 'Send Email',
    general: 'General',
    stopSell: 'Stop Sale',
    campaign: 'Campaign',
    report: 'Report',
    emailHistory: 'Email History'
  },
  th: {
    sendEmail: 'ส่งอีเมล',
    general: 'ทั่วไป',
    stopSell: 'หยุดการขาย',
    campaign: 'แคมเปญ',
    report: 'รายงาน',
    emailHistory: 'ประวัติการส่งอีเมล'
  }
}
